
























































import { Consent } from "@/api/open-api";
import { QTable } from "quasar";
import Vue from "vue";
export default Vue.extend({
  name: "c-user",
  methods: {
    getUserName() {
      if (this.$persistency.getItem("userData") != null) {
        const userData = JSON.parse(localStorage.getItem("userData") ?? "{}");
        return userData.display_name;
      }
    },

    getUserData() {
      if (this.$persistency.getItem("userData") != null) {
        const prova = JSON.parse(localStorage.getItem("userData") ?? "{}");
        return prova;
      }
    },
    logout() {
      this.$persistency.removeItem("accessToken");
      this.$router.push("/login");
    },
    isLoggedIn() {
      return !!this.$persistency.getItem("accessToken");
    }
  }
});
